module.exports = __webpack_public_path__ + "static/media/eco-ecology-leaf-2-svgrepo-com.d92cdc53.svg";